// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T6X8","placeholdersHeader":"styles_placeholdersHeader__3ufqB","editorStyle":"styles_editorStyle__2mZc8","placeholdersBox":"styles_placeholdersBox__1ibl_"};